<template>
  <div class="videoContainer" ref="videoContainer">
    <desktop-full-screen-overlay></desktop-full-screen-overlay>
    <div class="desktopTranscriptOverlay" v-if="initialPrefs.showDesktopOverlays && initialPrefs.showDesktopTranscript">
      <transcript-content :data="transcriptData"></transcript-content>
    </div>
    <vue-draggable-resizable
      class="videoDraggableCont"
      :lock-aspect-ratio="true"
      :w="640"
      :h="360"
      :x="160"
      :y="90"
      @dragging="onDrag"
      @resizing="onResize"
      :parent="false"
      :active="draggable"
      :draggable="draggable"
      :resizable="draggable"
      v-bind:class="isFullScreened ? 'fullScreened' : !draggable ? 'stuck' : ''"
    >
      <div
        id="videoContainer"
        v-bind:class="
          (isFullScreened ? 'fullScreened' : '') +
          (initialPrefs.showDesktopTranscript & initialPrefs.showDesktopOverlays
            ? ' transcriptVisible'
            : '')
        "
      >
        <div class="videoSeeker">
          <div class="contentButtons">
            <div class="webIcon" v-if="initialPrefs.videoLanguages">
              <web-icon></web-icon>
            </div>
          </div>
          <div class="stackedTitleSeeker">
            <div class="titleText">
              {{
                initialPrefs.PrimaryProjectTitle == ""
                  ? initialPrefs.SecondaryProjectTitle
                  : initialPrefs.PrimaryProjectTitle
              }}
            </div>
            <div class="seeker">
              <div class="timetext">{{ curVideoTime }}</div>
              <div
                class="barContainer"
                ref="barContainer"
                @click="mobileSeekerClicked"
              >
                <div class="barInnerContainer">
                  <div
                    class="bar"
                    v-bind:style="{ left: currentProgressBarPosition + '%' }"
                  ></div>
                </div>
                <div
                  :class="'seekCircle' + (controlsSeen ? ' active' : '')"
                  :style="
                    'left:calc(' +
                    (currentProgressBarPosition + 100) +
                    '% - 4px)'
                  "
                ></div>
              </div>
            </div>
          </div>
          <div class="contentButtons">
            <div class="searchButton" v-if="initialPrefs.hasSearchFeature">
              <fa-icon :icon="['fas', 'search']"></fa-icon>
            </div>
            <div class="slideButton" v-if="overlayContent.slides != null">
              <img
                src="../assets/slide.svg"
                :icon="['fas', 'file-powerpoint']"
                @click="toggleSlideInChild"
                @dblclick="doubleTappedSlideIcon"
              />
            </div>
          </div>
          <div class="playBtn">
            <div
              :class="preventVideoControlsInteraction ? 'dimmed icon' : 'icon'"
            >
              <div
                :style="
                  videoPlaying == true ? 'display: none;' : 'display: block;'
                "
              >
                <play-icon @click="play"></play-icon>
              </div>
              <div
                :style="
                  videoPlaying == false ? 'display: none;' : 'display:block;'
                "
              >
                <pause-icon @click="pause"></pause-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="videoInnerContainer">
          <div
            :class="
              'videoSwipeContainer ' + (isVideoHidden ? 'hiddenVideo' : '')
            "
            ref="videoSwipeContainer"
          >
            <div class="videoControlsAndVideo" ref="videoControlsAndVideo">
              <video
                ref="ActualVideo"
                crossorigin="anonymous"
                type="video/mp4"
                class="videodiv"
                playsinline
                preload="auto"
                :id="'video-' + initialPrefs.videoID"
                @ended="VideoEnded"
                @click="togglePlayPause"
                @play="videoPlay"
              ></video>
              <div
                class="initialOverlay"
                :style="
                  initialOverlayVisible ? 'display: flex' : 'display:none'
                "
                @click="hideInitialOverlay"
              >
                <div class="primaryTitle">
                  {{ initialPrefs.PrimaryProjectTitle }}
                </div>
                <div class="secondaryTitle">
                  {{ initialPrefs.SecondaryProjectTitle }}
                </div>
                <div
                  class="languageContainer"
                  v-if="initialPrefs.videoLanguages"
                >
                  <div class="leftText">Captions:</div>
                  <select-control
                    :label="'Select a language'"
                    :autoSelect="true"
                    @change="languageChanged"
                    :options="initialPrefs.videoLanguages"
                    :textField="'language'"
                    :id="'language'"
                    v-model="initialPrefs.curLanguage"
                  ></select-control>
                </div>
                <fa-icon :icon="['fas', 'play']" class="playIcon"></fa-icon>
                <div class="clickToPlayText">{{$t('Click Play To Start')}}</div>
              </div>
              <div
                class="videoControlsContent"
                ref="videoControlsContent"
                :style="
                  controlsSeen
                    ? preventVideoControlsInteraction
                      ? { display: 'none' }
                      : { display: 'flex' }
                    : { display: 'none' }
                "
              >
                <div class="upperContent"></div>
                <div
                  class="progressBarConatiner"
                  ref="progressBarConatiner"
                  @click="seekerClicked"
                  @mousedown="seekerMouseDown"
                >
                  <div class="progressLineContainer">
                    <div class="progressbarBase"></div>
                    <div
                      class="progressbarProgress"
                      v-bind:style="
                        'transform: translateX(' +
                        currentProgressBarPosition +
                        '%)'
                      "
                    ></div>
                  </div>
                  <div
                    :class="
                      hoverTimeActive == false
                        ? 'progressbarHoverTimeContainer inactive'
                        : 'progressbarHoverTimeContainer'
                    "
                    ref="progressbarHoverTimeContainer"
                  ></div>
                  <div
                    :class="
                      hoverTimeActive == false
                        ? 'progressbarHoverTriangle inactive'
                        : 'progressbarHoverTriangle'
                    "
                    ref="progressbarHoverTriangle"
                  ></div>
                  <div class="progressbarCircleContiner">
                    <div
                      class="progressbarCircle"
                      v-bind:style="
                        'left:' + (currentProgressBarPosition + 100) + '%'
                      "
                    ></div>
                  </div>
                </div>
                <div class="controlsConatiner">
                  <div class="leftConainer">
                    <fa-icon
                      :icon="['fas', 'play']"
                      @click="play"
                      v-bind:style="
                        videoPlaying == true
                          ? { display: 'none' }
                          : { display: 'block' }
                      "
                    ></fa-icon>
                    <fa-icon
                      :icon="['fas', 'pause']"
                      @click="pause"
                      v-bind:style="
                        videoPlaying == false
                          ? { display: 'none' }
                          : { display: 'block' }
                      "
                    ></fa-icon>
                    <fa-icon
                      :icon="['fas', 'volume-up']"
                      @click="muteVideo"
                      v-bind:style="
                        curVolume >= 0.5 && isMuted == false
                          ? { display: 'block' }
                          : { display: 'none' }
                      "
                    ></fa-icon>
                    <fa-icon
                      :icon="['fas', 'volume-down']"
                      @click="muteVideo"
                      v-bind:style="
                        curVolume < 0.5 && curVolume != 0 && isMuted == false
                          ? { display: 'block' }
                          : { display: 'none' }
                      "
                    ></fa-icon>
                    <fa-icon
                      :icon="['fas', 'volume-mute']"
                      @click="unmuteVideo"
                      v-bind:style="
                        isMuted || curVolume == 0
                          ? { display: 'block' }
                          : { display: 'none' }
                      "
                    ></fa-icon>
                    <div
                      class="volumeSlideContainer"
                      ref="volumeSlideContainer"
                      @click="volumeSliderClicked"
                      @mousedown="volumeSliderMouseDown"
                    >
                      <div class="volumeLineContainer">
                        <div class="voulmebarBase"></div>
                        <div
                          class="voulmebarProgress"
                          v-bind:style="
                            'transform:translateX(' +
                            (curVolume * 100 - 100) +
                            '%)'
                          "
                        ></div>
                      </div>
                      <div class="volumeCircleContainer">
                        <div
                          class="volumebarCircle"
                          v-bind:style="'left:' + curVolume * 100 + '%'"
                        ></div>
                      </div>
                    </div>
                    <div class="timetext">
                      {{ curVideoTime }} / {{ curVideoFullTime }}
                    </div>
                  </div>
                  <div class="rightConainer">
                    <fa-icon
                      :icon="['fas', 'search']"
                      v-if="initialPrefs.transcriptAvailable"
                    ></fa-icon>

                    <fa-icon
                      :icon="['fas', 'file-powerpoint']"
                      @click="toggleSlideInChild"
                      v-if="initialPrefs.slideVisible"
                    ></fa-icon>
                    <fa-icon
                      v-if="
                        initialPrefs.draggableVideo &&
                        !isFullScreened &&
                        !draggable
                      "
                      :icon="['fas', 'window-minimize']"
                      @click="toggleDraggalbe"
                    ></fa-icon>
                    <fa-icon
                      v-if="
                        initialPrefs.draggableVideo &&
                        !isFullScreened &&
                        draggable
                      "
                      :icon="['fas', 'square']"
                      @click="toggleDraggalbe"
                    ></fa-icon>
                    <fa-icon
                      :icon="['fas', 'expand']"
                      @click="gofullScreen"
                      v-bind:style="
                        isFullScreened == true
                          ? { display: 'none' }
                          : { display: 'block' }
                      "
                    ></fa-icon>
                    <fa-icon
                      :icon="['fas', 'compress-arrows-alt']"
                      @click="nofullScreen"
                      v-bind:style="
                        isFullScreened == true
                          ? { display: 'block' }
                          : { display: 'none' }
                      "
                    ></fa-icon>
                  </div>
                </div>
              </div>
              <div
                class="videoLoadingCircle"
                v-bind:style="
                  isVideoBuffering == true
                    ? { display: 'flex' }
                    : { display: 'none' }
                "
              >
                <div class="loader"></div>
              </div>
            </div>
            <div
              :class="'unhideContainer ' + (isVideoHidden ? 'hiddenVideo' : '')"
            >
              <div class="unhideArrow" @click="unhideVideo">
                <fa-icon :icon="['fas', 'arrow-alt-circle-down']"></fa-icon>
              </div>
            </div>
          </div>
          <div class="videoOverlayContent">
            <OverlayContent
              :overlayContent="overlayContent"
              :videoHeight="videoHeight || undefined"
              :videoWidth="videoWidth || undefined"
              ref="OverlayContent"
            ></OverlayContent>
          </div>
        </div>
      </div>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import timeMixin from "../mixins/timeMixin";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { getVideoURL } from "../main.js";
import SelectControl from "./controls/select-control.vue";
import desktopFullScreenOverlay from './desktop-full-screen-overlay.vue'
import TranscriptContent from './transcriptContent.vue';
// import Vue from 'vue'

export default {
  props: {
    overlayContent: {
      type: Object,
      required: true,
    },
  },
  components: {
    'desktop-full-screen-overlay':desktopFullScreenOverlay,
    SelectControl,
    OverlayContent: () =>
      import(/* webpackChunkName: "overlay-content" */ "./overlay-content"),
    "vue-draggable-resizable": VueDraggableResizable,
    TranscriptContent,
  },
  computed:{
    transcriptData(){
      return {
        ...this.overlayContent.menu.find(x=>x.type=='transcriptContent').data,
        isDesktopOverlay:true
      }
    }
  },
  async mounted() {
    window.videoID = this.initialPrefs.videoID;
    window.addEventListener("resize", () => {
      this.resize();
    });
    window.addEventListener("orientationchange", () => {
      this.orientationChanged();
    });
    this.$refs.ActualVideo.addEventListener("waiting", () => {
      this.isVideoBuffering = true;
    });
    this.$refs.ActualVideo.addEventListener("canplay", () => {
      this.isVideoBuffering = false;
    });
    this.$refs.ActualVideo.addEventListener("ended", () => {
      if (this.initialPrefs.sendEventsToDataLayer) {
        this.$gtag.event("videoEvent", {
          videoCategory: "Springer Healthcare Interactive Video",
          videoAction: "Video Completes",
          videoId: this.initialPrefs.videoID,
          videoName: this.initialPrefs.projectName,
          videoAutoplay: false,
          videoDuration: 3661,
          videoLive: "false",
        });
      }
    });
    this.$refs.ActualVideo.addEventListener("loadedmetadata", () => {
      this.videoWidth = this.$refs.ActualVideo.videoWidth;
      this.videoHeight = this.$refs.ActualVideo.videoHeight;
      this.curVideoFullTime = this.convertSecondsToHourMinsSecs(3661);
      if (navigator.platform.match(/iPhone|iPod|iPad/))
        this.isVideoBuffering = false;
    });

    this.$refs.progressBarConatiner.addEventListener(
      "mousemove",
      this.showTimeOnHover
    );
    this.$refs.progressBarConatiner.addEventListener(
      "mouseout",
      this.hiderTimeOnOut
    );

    this.$refs.barContainer.addEventListener(
      "touchstart",
      this.mobileSeekerTouchStart
    );
    if (this.initialPrefs.sendEventsToDataLayer) {
      this.$gtag.event("videoEvent", {
        videoCategory: "Springer Healthcare Interactive Video",
        videoAction: "Video Loaded",
        videoId: this.initialPrefs.videoID,
        videoName: this.initialPrefs.projectName,
        videoAutoplay: false,
        videoDuration: 3661,
        videoLive: "false",
      });
    }
    this.$refs.videoSwipeContainer.addEventListener(
      "touchstart",
      this.videoSwipeTouchStart
    );
  },
  async created() {
    this.initialOverlayVisible = this.initialPrefs.initialOverlayVisible;
    this.controlsSeen = !this.initialOverlayVisible;
    document.addEventListener("beforeunload", this.beforeUnload);
    var sourceURL = await getVideoURL();
    if (navigator.platform.match(/iPhone|iPod|iPad/)) {
      this.$refs.ActualVideo.innerHTML =
        '<source src="' +
        sourceURL["auto"][0].source +
        '" type="application/vnd.apple.mpegurl">';
    } else {
      this.$refs.ActualVideo.innerHTML =
        '<source src="' + sourceURL["720p"][0].source + '" type="video/mp4">';
    }
    this.$root.$on("pauseVideo", this.pause);
    this.$root.$on("playVideo", this.play);
    this.$root.$on("seekVideo", (e) => {
      this.seekTo(e);
    });
  },
  methods: {
    videoSwipeTouchStart(event) {
      if (this.isMobileView) {
        this.videoSwipeStartYPos = event.touches[0].pageY;
        this.$refs.videoSwipeContainer.addEventListener(
          "touchmove",
          this.videoSwipeTouchMove
        );
        this.$refs.videoSwipeContainer.addEventListener(
          "touchend",
          this.videoSwipeTouchEnd
        );
      }
    },
    videoSwipeTouchMove(event) {
      var videoHeight =
        this.$refs.videoControlsAndVideo.getBoundingClientRect().height / 2;
      var opacity =
        (this.videoSwipeStartYPos - event.touches[0].pageY) / videoHeight;
      if (opacity > 0) {
        this.$refs.videoControlsAndVideo.style.opacity = 1 - opacity;
      }
      if (opacity >= 1) {
        this.beforeVideoHiddenVar = true;
      } else {
        this.beforeVideoHiddenVar = false;
      }
    },
    videoSwipeTouchEnd() {
      if (this.beforeVideoHiddenVar) {
        this.$refs.videoSwipeContainer.style.height =
          this.$refs.videoSwipeContainer.getBoundingClientRect().height + "px";
        this.$nextTick(() => {
          this.isVideoHidden = true;
        });
      } else {
        this.$refs.videoControlsAndVideo.style.opacity = 1;
      }
    },
    unhideVideo() {
      this.isVideoHidden = false;
      this.beforeVideoHiddenVar = false;
      this.$refs.videoControlsAndVideo.style.opacity = 1;
    },
    showTimeOnHover(e) {
      if (isNaN(3661)) return;
      this.$refs.progressbarHoverTimeContainer.innerHTML =
        this.convertSecondsToHourMinsSecs(
          parseInt(
            (e.offsetX /
              this.$refs.progressBarConatiner.getBoundingClientRect().width) *
              3661
          )
        );
      this.hoverTimeActive = true;
      this.$refs.progressbarHoverTriangle.style.transform =
        "translateX(" + (e.offsetX - 10) + "px)";
      var Boxleft =
        e.offsetX -
        this.$refs.progressbarHoverTimeContainer.getBoundingClientRect().width /
          2;
      if (Boxleft < -10) {
        Boxleft = -10;
      } else if (
        Boxleft >
        this.$refs.progressBarConatiner.getBoundingClientRect().width -
          this.$refs.progressbarHoverTimeContainer.getBoundingClientRect()
            .width +
          10
      )
        Boxleft =
          this.$refs.progressBarConatiner.getBoundingClientRect().width -
          this.$refs.progressbarHoverTimeContainer.getBoundingClientRect()
            .width +
          10;
      this.$refs.progressbarHoverTimeContainer.style.transform =
        "translateX(" + Boxleft + "px)";
    },
    hiderTimeOnOut() {
      this.hoverTimeActive = false;
    },
    mobileSeekerTouchStart(e) {
      document.addEventListener("touchmove", this.touchMove);
      document.addEventListener("touchend", this.touchEnd);
      this.setSeekerBasedOnTouchOffset(
        e.touches[0].clientX -
          this.$refs.barContainer.getBoundingClientRect().x,
        true
      );

      this.pauseEvent(e);
    },
    touchMove(e) {
      this.setSeekerBasedOnTouchOffset(
        e.touches[0].clientX -
          this.$refs.barContainer.getBoundingClientRect().x,
        true
      );
    },
    touchEnd() {
      document.removeEventListener("touchmove", this.touchMove);
      document.removeEventListener("touchend", this.touchEnd);
    },
    setSeekerBasedOnTouchOffset(offset, isMouseMove) {
      this.seekTo(
        (offset / this.$refs.barContainer.getBoundingClientRect().width) *
          3661,
        isMouseMove
      );
      requestAnimationFrame(this.setTimeText);
    },
    mobileSeekerClicked(e) {
      this.setSeekerBasedOnTouchOffset(e.offsetX, false);
    },
    beforeUnload() {
      if (this.initialPrefs.sendEventsToDataLayer) {
        this.$gtag.event("videoEvent", {
          videoCategory: "Springer Healthcare Interactive Video",
          videoAction: "Browser Closed",
          videoId: this.initialPrefs.videoID,
          videoName: this.initialPrefs.projectName,
          videoAutoplay: false,
          videoDuration: 3661,
          videoLive: "false",
        });
      }
    },
    videoPlay() {
      if (!this.videoPlaying) this.play();
    },
    play() {
      if(this.$refs.ActualVideo.currentTime>3661){
        this.$refs.ActualVideo.currentTime = 0;
      }
      this.lastPlayStartTime = this.$refs.ActualVideo.currentTime;
      this.$refs.ActualVideo.play();
      this.videoPlaying = true;
      this.playertextInterval = setInterval(() => {
        this.setTimeText();
      }, this.timeTextChangeInterval);
      window.addEventListener("mousemove", this.resetControlsTimeout);
      this.resetControlsTimeout();
      if (this.initialPrefs.sendEventsToDataLayer) {
        this.$gtag.event("videoEvent", {
          videoCategory: "Springer Healthcare Interactive Video",
          videoAction: this.videoPlayedOnce ? "Video Plays" : "Video Begins",
          videoId: this.initialPrefs.videoID,
          videoName: this.initialPrefs.projectName,
          videoAutoplay: false,
          videoDuration: 3661,
          videoLive: "false",
        });
      }
      this.videoPlayedOnce = true;
    },
    resetControlsTimeout() {
      clearTimeout(this.controlsTimeoutFunc);
      this.controlsSeen = true;
      this.controlsTimeoutFunc = setTimeout(() => {
        this.controlsSeen = false;
      }, this.controlsTimeout);
    },
    VideoEnded() {
      this.pause();
    },
    pause() {
      this.addTotalViewedTime();
      this.$refs.ActualVideo.pause();
      this.videoPlaying = false;
      clearInterval(this.playertextInterval);
      clearTimeout(this.controlsTimeoutFunc);
      this.controlsSeen = true;
      window.removeEventListener("mousemove", this.resetControlsTimeout);
      if (this.initialPrefs.sendEventsToDataLayer) {
        this.$gtag.event("videoEvent", {
          videoCategory: "Springer Healthcare Interactive Video",
          videoAction: "Video Pauses",
          videoId: this.initialPrefs.videoID,
          videoName: this.initialPrefs.projectName,
          videoAutoplay: false,
          videoDuration: 3661,
          videoLive: "false",
        });
      }
    },
    addTotalViewedTime() {
      this.totalPlayTime +=
        this.$refs.ActualVideo.currentTime - this.lastPlayStartTime;
      this.lastPlayStartTime = this.$refs.ActualVideo.currentTime;
    },
    setTimeText() {
      if (!this.$refs.ActualVideo) return;
      var curTime = this.$refs.ActualVideo.currentTime;
      this.$refs.OverlayContent.runMethods(curTime);
      this.$parent.runMethods(curTime);
      this.currentProgressBarPosition =
        (curTime / 3661).toFixed(2) * 100 - 100;
      this.curVideoTime = this.convertSecondsToHourMinsSecs(curTime);
      if (this.initialPrefs.sendEventsToDataLayer && parent?.dataLayer) {
        if (parseInt(curTime) % 5 == 0) this.addTotalViewedTime();
        var percent = parseInt(
          (this.totalPlayTime / 3661) * 20
        ) * 5
        if (percent > this.lastLoggedPercent) {
          this.$gtag.event("videoEvent", {
            videoCategory: "Springer Healthcare Interactive Video",
            videoAction: percent + "% percentage watched milestone passed",
            videoId: this.initialPrefs.videoID,
            videoName: this.initialPrefs.projectName,
            videoAutoplay: false,
            videoDuration: 3661,
            videoLive: "false",
          });
          this.lastLoggedPercent = percent;
        }
      }
      //pause video at 1:1:00
      if(this.$refs.ActualVideo.currentTime>3661&&this.$refs.ActualVideo.currentTime<3662){
        this.pause()
      }
    },
    resize() {
      var newisMobileView = window.innerWidth <= window.mobileWidth;
      this.isMobileView = newisMobileView;
    },
    padDigits(number, digits) {
      return (
        Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
      );
    },
    orientationChanged() {
      if (window.orientation != 90 && window.orientation != -90)
        alert(
          "User Interface is made with mobile device in mind. Please make sure the device is in potrait mode."
        );
    },
    toggleSlideInChild() {
      this.$parent.toggleSlide();
    },
    gofullScreen() {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen();
      } else if (document.body.webkitRequestFullscreen) {
        document.body.webkitRequestFullscreen();
      } else if (document.body.msRequestFullscreen) {
        document.body.msRequestFullscreen();
      }
      this.isFullScreened = true;
      // Vue.set(this.initialPrefs,'showDesktopOverlays',true)
    },
    nofullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isFullScreened = false;
      // Vue.set(this.initialPrefs,'showDesktopOverlays',false)
    },
    volumeSliderClicked(e) {
      this.addTotalViewedTime();
      this.setVolumeBasedOnMouseOffset(e.offsetX);
    },
    muteVideo() {
      this.$refs.ActualVideo.muted = true;
      this.isMuted = true;
    },
    unmuteVideo() {
      this.$refs.ActualVideo.muted = false;
      if (this.curVolume == 0) this.curVolume = 0.4;
      this.isMuted = false;
    },
    seekerClicked(e) {
      this.setSeekerBasedOnMouseOffset(e.offsetX, false);
    },
    volumeSliderMouseDown(e) {
      this.addTotalViewedTime();
      document.addEventListener("mouseup", this.volumeSliderMouseUp);
      document.addEventListener("mousemove", this.volumeSliderMouseMove);
      this.setVolumeBasedOnMouseOffset(e.offsetX);
      this.pauseEvent(e);
    },
    volumeSliderMouseMove(e) {
      this.setVolumeBasedOnMouseOffset(
        e.x - this.$refs.volumeSlideContainer.getBoundingClientRect().x
      );
    },
    volumeSliderMouseUp() {
      document.removeEventListener("mousemove", this.volumeSliderMouseMove);
      document.removeEventListener("mouseup", this.volumeSliderMouseUp);
    },
    setVolumeBasedOnMouseOffset(offset) {
      var value = offset / 80; // 80 voulme bar length
      if (value < 0) {
        value = 0;
      } else if (value >= 1) {
        value = 1;
      }
      var that = this;
      that.$refs.ActualVideo.volume = value;
      requestAnimationFrame(function () {
        that.curVolume = that.$refs.ActualVideo.volume;
        that.isMuted = false;
      });
    },
    pauseEvent(e) {
      if (e.stopPropagation) e.stopPropagation();
      if (e.preventDefault) e.preventDefault();
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    },
    seekerMouseDown(e) {
      this.addTotalViewedTime();
      document.addEventListener("mouseup", this.seekerMouseUp);
      document.addEventListener("mousemove", this.seekerMouseMove);
      this.setSeekerBasedOnMouseOffset(e.offsetX, true);
      this.pauseEvent(e);
    },
    seekerMouseMove(e) {
      this.setSeekerBasedOnMouseOffset(
        e.x - this.$refs.progressBarConatiner.getBoundingClientRect().x,
        true
      );
    },
    seekerMouseUp() {
      document.removeEventListener("mousemove", this.seekerMouseMove);
      document.removeEventListener("mouseup", this.seekerMouseUp);
    },
    setSeekerBasedOnMouseOffset(offset, isMouseMove) {
      this.seekTo(
        (offset /
          this.$refs.progressBarConatiner.getBoundingClientRect().width) *
          3661,
        isMouseMove
      );
      requestAnimationFrame(this.setTimeText);
    },
    togglePlayPause(e) {
      if (this.dragged == true) {
        this.dragged = false;
        return;
      }
      if (e.target != this.$refs.ActualVideo) return;
      window.addEventListener("mousemove", this.resetControlsTimeout);
      this.resetControlsTimeout();
      this.videoPlaying = !this.videoPlaying;
      if (this.videoPlaying) this.play();
      else this.pause();
    },
    hideInitialOverlay() {
      if (this.dragged == true) {
        this.dragged = false;
        return;
      }
      this.initialOverlayVisible = false;
      this.controlsSeen = true;
      this.isVideoBuffering = false;
      this.play();
    },
    seekTo(time, isMouseMove) {
      var computedTime = this.$refs.OverlayContent.checkforChanges(
        this.$refs.ActualVideo.currentTime,
        time
      );
      if (computedTime != null) {
        this.$refs.ActualVideo.currentTime = computedTime;
        if (isMouseMove) {
          this.seekerMouseUp();
        }
      } else {
        this.$refs.ActualVideo.currentTime = time;
      }
      if (isMouseMove == false) {
        if (this.initialPrefs.sendEventsToDataLayer) {
          this.$gtag.event("videoEvent", {
            videoCategory: "Springer Healthcare Interactive Video",
            videoAction: "Seeked",
            videoId: this.initialPrefs.videoID,
            videoName: this.initialPrefs.projectName,
            videoAutoplay: false,
            videoDuration: 3661,
            videoLive: "false",
          });
        }
      }
    },
    stopControlInteraction() {
      this.preventVideoControlsInteraction = true;
    },
    allowControlInteraction() {
      this.preventVideoControlsInteraction = false;
    },
    onResize: function (x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
    },
    onDrag: function (x, y) {
      this.x = x;
      this.y = y;
      this.dragged = true;
    },
    toggleDraggalbe() {
      this.draggable = !this.draggable;
    },
    seektoTime(time, play) {
      this.seekTo(time);
      if (play) {
        this.play();
      }
    },
    async languageChanged(language) {
      let lang = this.initialPrefs.videoLanguages.find(
        (x) => x.language === language
      );
      var sourceURL = await getVideoURL(lang.videoId);
      if (navigator.platform.match(/iPhone|iPod|iPad/)) {
        this.$refs.ActualVideo.innerHTML =
          '<source src="' +
          sourceURL["auto"][0].source +
          '" type="application/vnd.apple.mpegurl">';
        this.$refs.ActualVideo.src = sourceURL["720p"][0].source;
      } else {
        this.$refs.ActualVideo.innerHTML =
          '<source src="' + sourceURL["720p"][0].source + '" type="video/mp4">';
        this.$refs.ActualVideo.src = sourceURL["720p"][0].source;
      }
      if (this.videoPlaying) {
        this.$refs.ActualVideo.play();
      }
    },
    doubleTappedSlideIcon(){
      this.$parent.resetSlidePlayerPostion();
    }
  },
  data() {
    return {
      videoPlaying: false,
      curVideoTime: "0:00:00",
      curVideoFullTime: "0:00:00",
      timeTextChangeInterval: 500,
      currentProgressBarPosition: -100,
      isMobileView: window.innerWidth <= window.mobileWidth,
      playertextInterval: null,
      isVideoBuffering: true,
      isFullScreened: false,
      curVolume: 1,
      isMuted: false,
      controlsTimeout: 3000,
      controlsSeen: false,
      initialOverlayVisible: false,
      preventVideoControlsInteraction: false,
      lastPlayStartTime: 0,
      totalPlayTime: 0,
      lastLoggedPercent: 0,
      dragged: false,
      draggable: false,
      hoverTimeActive: false,
      videoSwipeStartYPos: null,
      beforeVideoHiddenVar: false,
      isVideoHidden: false,
      videoPlayedOnce: false,
      videoWidth:null,
      videoHeight:null,
    };
  },
  mixins: [timeMixin],
};
</script>
